import { apiClient } from './apiClient';
import { PaginatedResponse, Payment } from '../types';

type UploadableFile =
  | File
  | {
      uri: string;
      name: string;
      type: string;
    };

export const paymentService = {
  async list(params?: {
    deal?: string;
    status?: string;
    page?: number;
  }): Promise<PaginatedResponse<Payment>> {
    const { data } = await apiClient.get<PaginatedResponse<Payment>>('/payments/', { params });
    return data;
  },

  async submitPop(payload: {
    conversation_id?: string;
    deal_id?: string;
    amount?: number;
    method?: Payment['method'];
    proof_image: UploadableFile;
  }): Promise<Payment> {
    const form = new FormData();
    if (payload.conversation_id) form.append('conversation_id', payload.conversation_id);
    if (payload.deal_id) form.append('deal_id', payload.deal_id);
    if (payload.amount) form.append('amount', String(payload.amount));
    if (payload.method) form.append('method', payload.method);
    form.append('proof_image', payload.proof_image as any);
    const { data } = await apiClient.post<Payment>('/payments/submit-pop/', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },

  async approve(paymentId: string): Promise<Payment> {
    const { data } = await apiClient.post<Payment>(`/payments/${paymentId}/approve/`);
    return data;
  },

  async reject(paymentId: string, reason?: string): Promise<Payment> {
    const { data } = await apiClient.post<Payment>(`/payments/${paymentId}/reject/`, { reason });
    return data;
  },
};
